/* ============================================================
   FLAVORPIX™ FLAVOR SELECTOR — assets/fp-flavor-selector.js
   - Carousel logic (positions relatives -2/-1/0/+1)
   - Sync avec window.flavorpix global state
   - Clic tube central = scroll vers la section pack (#the-pack)
   - Swipe touch + clavier arrow nav
   ============================================================ */

(function () {
  'use strict';

  const FLAVORS = ['mint', 'peach', 'coffee', 'blueberry'];

  document.querySelectorAll('[data-fp-selector]').forEach(initSelector);

  function initSelector(root) {
    const slots = root.querySelectorAll('[data-fp-flavor]');
    const dots = root.querySelectorAll('[data-fp-dot]');
    const infoPanels = root.querySelectorAll('[data-fp-info-for]');
    const navPrev = root.querySelector('[data-fp-nav="prev"]');
    const navNext = root.querySelector('[data-fp-nav="next"]');

    if (!slots.length) return;

    function updatePositions(activeFlavor) {
      const activeIdx = FLAVORS.indexOf(activeFlavor);
      if (activeIdx === -1) return;

      slots.forEach((slot) => {
        const slotFlavor = slot.getAttribute('data-fp-flavor');
        const slotIdx = FLAVORS.indexOf(slotFlavor);

        let rel = slotIdx - activeIdx;
        if (rel > 2) rel -= FLAVORS.length;
        if (rel < -2) rel += FLAVORS.length;

        slot.setAttribute('data-rel-position', rel);
        slot.setAttribute('aria-selected', rel === 0 ? 'true' : 'false');
        slot.setAttribute('tabindex', rel === 0 ? '0' : '-1');
        if (rel === 0) {
          slot.setAttribute('title', 'Voir le pack');
        } else {
          slot.removeAttribute('title');
        }
      });

      dots.forEach((dot) => {
        const flavor = dot.getAttribute('data-fp-dot');
        if (flavor === activeFlavor) {
          dot.setAttribute('data-active', 'true');
        } else {
          dot.removeAttribute('data-active');
        }
      });

      infoPanels.forEach((panel) => {
        const flavor = panel.getAttribute('data-fp-info-for');
        if (flavor === activeFlavor) {
          panel.setAttribute('data-active', 'true');
        } else {
          panel.removeAttribute('data-active');
        }
      });
    }

    const initialFlavor = (window.flavorpix && window.flavorpix.getFlavor())
      || 'mint';
    updatePositions(initialFlavor);

    function selectFlavor(flavor) {
      if (!FLAVORS.includes(flavor)) return;
      if (window.flavorpix) {
        window.flavorpix.setFlavor(flavor);
      }
    }

    // Ouvre le pack : scroll fluide vers la section pack de la home
    function openPack() {
      const target = document.querySelector('#the-pack');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }

    // Clic slot : si déjà centré -> ouvre le pack ; sinon -> centre la saveur
    slots.forEach((slot) => {
      slot.addEventListener('click', () => {
        const flavor = slot.getAttribute('data-fp-flavor');
        const current = (window.flavorpix && window.flavorpix.getFlavor()) || 'mint';
        if (flavor === current) {
          openPack();
        } else {
          selectFlavor(flavor);
        }
      });
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const flavor = dot.getAttribute('data-fp-dot');
        selectFlavor(flavor);
      });
    });

    function navigate(direction) {
      const current = (window.flavorpix && window.flavorpix.getFlavor()) || 'mint';
      const idx = FLAVORS.indexOf(current);
      let nextIdx = idx + direction;
      if (nextIdx < 0) nextIdx = FLAVORS.length - 1;
      if (nextIdx >= FLAVORS.length) nextIdx = 0;
      selectFlavor(FLAVORS[nextIdx]);
    }

    if (navPrev) navPrev.addEventListener('click', () => navigate(-1));
    if (navNext) navNext.addEventListener('click', () => navigate(1));

    root.addEventListener('keydown', (e) => {
      if (!root.contains(document.activeElement)) return;
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        navigate(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        navigate(1);
      }
    });

    let touchStartX = 0;
    let touchStartY = 0;
    const SWIPE_THRESHOLD = 50;

    const carousel = root.querySelector('.fp-selector__carousel');
    if (carousel) {
      carousel.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });

      carousel.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - touchStartX;
        const dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > SWIPE_THRESHOLD) {
          navigate(dx < 0 ? 1 : -1);
        }
      }, { passive: true });
    }

    if (window.flavorpix && window.flavorpix.onChange) {
      window.flavorpix.onChange((flavor) => {
        updatePositions(flavor);
      });
    }
  }
})();
